import { render, staticRenderFns } from "./ReportImage.vue?vue&type=template&id=a486d40a&scoped=true&"
import script from "./ReportImage.vue?vue&type=script&lang=js&"
export * from "./ReportImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a486d40a",
  null
  
)

export default component.exports